import { Filter, getFilterValues } from 'framework/list';
import type { ProjectTeamMemberDto } from 'domain/shared/newProject';
import ProjectTeamMemberMultiSelectFilter from './ProjectTeamMemberMultiSelectFilter';

export const EMPLOYEE_FILTER_SOURCE = 'employeeAliases';

export const getSelectedEmployeeAliases = (filters: Filter): string[] =>
  getFilterValues(filters, EMPLOYEE_FILTER_SOURCE);

export const EmployeeAliasesFilter = ({ members }: { members: ProjectTeamMemberDto[] }) => (
  <ProjectTeamMemberMultiSelectFilter source={EMPLOYEE_FILTER_SOURCE} label="Worker" members={members} />
);
